<template>
    <div>
        <div :class="{'dropdown-content': !inline, 'dropdown-content-padded': !inline}">
            <p v-if="isLoading">The options are being fetch</p>
            <p v-else>There are {{options.length}} possible values for: {{filter.filter.label}}.</p>
        </div>
        <div class="dropdown-content dropdown-content-padded" :class="{'is-scrollable': options.length > 6}"
             v-if="!isLoading">
            <ul class="list list-group">
                <li
                    class="list-item"
                    v-for="option in options"
                    :key="option.value">
                    <v-checkbox
                        :label="option.label"
                        :value="option.value"
                        v-model="selectedOptions"
                        @input="updateValue"/>
                </li>
            </ul>
        </div>
        <slot v-if="$slots.footer" name="footer"/>
        <filter-footer v-else @update="updateFilter"/>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';
    import vCheckbox from '@/components/form/v-checkbox';
    import filterMixins from './filter-mixins';
    import FilterFooter from './filter-footer';

    export default {
        mixins: [filterMixins],
        components: {vIcon, vCheckbox, FilterFooter},
        data() {
            return {
                options: [],
                selectedOptions: [],
                isLoading: false,
            };
        },
        computed: {
            filterOptions() {
                return this.filter.filter.options;
            },
        },
        methods: {
            makePayload() {
                return this.adapter.getFilterPayload({
                    index: this.index,
                    filter: this.filter,
                    assign: {values: this.selectedOptions},
                });
            },
            updateValue() {
                if (!this.inline) {
                    return;
                }
                this.$nextTick(() => {
                    const payload = this.makePayload();
                    this.$emit('input', payload);
                });
            },
            updateFilter() {
                const payload = this.makePayload();
                this.$emit('update', payload);
                this.$parent.$emit('request-popper-hide');
            },
            async loadOptions() {
                this.isLoading = true;
                try {
                    this.options = await this.filterOptions.getAll();
                    this.selectedOptions = this.filter.condition.values || [];
                } catch (error) {
                    this.options = [];
                // Todo: User error notification (intercom - toast message)
                } finally {
                    this.isLoading = false;
                }
            },
        },
        mounted() {
            this.loadOptions();
        },
    };
</script>
